<div id="notfound" class="padding-align">
    <div class="notfound">
        <div class="notfound-404">
        <h1>{{displayMessage | translate}}</h1>
        </div>
    </div>
</div>
  